<template>
     <div class="m-auto z-10 sm:px-0 w-auto text-center">
          <div class="w-[90%] mx-auto sm:max-w-md ">
               <slot/>
          </div>
     </div>
</template>